export default __webpack_public_path__ + "static/media/190629_190332_IMG_2706.e83c16f7.jpg";